import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import userService from "../../../services/userService";
import { resolveUserDisplayName } from "../../../utils/userIdentity";

import "./index.scss";

export default function UserChip({ user, onClick }) {
    const [hovered, setHovered] = useState(false);
    const [profile, setProfile] = useState(null);
    const ref = useRef(null);
    const [pos, setPos] = useState({ top: 0, left: 0 });

    useEffect(() => {
        if (!hovered) return;
        const rect = ref.current?.getBoundingClientRect();
        if (rect) {
            setPos({ top: rect.bottom + 8, left: rect.left });
        }
        if (!profile && user?.userId) {
            userService.fetchUserById(user.userId).then(setProfile).catch(() => {});
        }
    }, [hovered, profile, user?.userId]);

    const label = `@${user?.username || profile?.username || user?.userId}`;

    return (
        <>
            <button
                ref={ref}
                type="button"
                className="user-chip"
                onClick={(e) => { e.stopPropagation(); onClick?.(user); }}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                <span className="user-chip__at">@</span>
                <span className="user-chip__name">{user?.username}</span>
            </button>
            {hovered && (
                <div className="user-hovercard" style={{ position: "fixed", top: pos.top, left: pos.left }} role="tooltip">
                    <strong className="user-hovercard__title">{label}</strong>
                    <p className="user-hovercard__meta">{resolveUserDisplayName(profile, 'Friend')}</p>
                </div>
            )}
        </>
    );
}

UserChip.propTypes = {
    user: PropTypes.shape({
        userId: PropTypes.string.isRequired,
        username: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func,
};
